import React from 'react';
import styled from 'styled-components';

// Lista de imágenes (puedes reemplazar esto con tus propias imágenes)
const images = [
  './img/banners/image0.jpg',
  './img/banners/image1.jpg',
  './img/banners/image2.jpg',
  './img/banners/image3.jpg',
  './img/banners/image0.jpg',
  './img/banners/image1.jpg',
  // Añade más imágenes según sea necesario
];

// Contenedor de la galería usando styled-components
const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* Auto-ajuste */
  gap: 16px;
  padding: 16px;
  margin: 0;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

// Estilos de cada item de la galería
const GalleryItem = styled.div`
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

// Estilo para la imagen dentro del item
const GalleryImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
`;

const ComponentGallery = () => {
  return (
    <GalleryContainer>
      {images.map((image, index) => (
        <GalleryItem key={index}>
          <GalleryImage src={image} alt={`image ${index + 1}`} />
        </GalleryItem>
      ))}
    </GalleryContainer>
  );
};

export default ComponentGallery;
